<div class="table-responsive table-matrix">
  <table
    class="table table-striped table-sm table-bordered table-hover bsg-table matrix"
    [ngClass]="{ 'sticky-left': isStickyCol() }">
    <thead>
      <tr>
        <th
          class="text-center element-number"
          [ngClass]="{
            'matrix-column-large': getColumnsToDisplay().length <= 1,
            'sticky-top': isStickyRow(),
          }">
          @if (notApplicablePointGroupsDisplayed) {
            <button
              ngbPopover="{{ 'NZ-Punktegruppen ausblenden' | translate }}"
              placement="right"
              triggers="mouseenter:mouseleave"
              class="btn btn-link btn-expand"
              (click)="notApplicablePointGroupsDisplayed = !notApplicablePointGroupsDisplayed">
              <span class="fas fa-angle-double-left"></span>
            </button>
          }
          @if (!notApplicablePointGroupsDisplayed) {
            <button
              ngbPopover="{{ 'NZ-Punktegruppen einblenden' | translate }}"
              placement="right"
              triggers="mouseenter:mouseleave"
              class="btn btn-link btn-expand"
              (click)="notApplicablePointGroupsDisplayed = !notApplicablePointGroupsDisplayed">
              <span class="fas fa-angle-double-right"></span>
            </button>
          }
        </th>
        <th
          class="matrix-point-header"
          [ngClass]="{
            'matrix-column-large': getColumnsToDisplay().length <= 1,
            'sticky-top': isStickyRow(),
          }">
          <h3>
            @if (categoryDetail.categoryName) {
              <span>{{ categoryDetail.categoryName | i18nText }}</span>
            }
            <span>&nbsp;({{ categoryDetail.categoryNumber }})</span>
          </h3>
        </th>
        @if (displayRowPointTemplateColumn() || !getColumnsToDisplay().length) {
          <th
            class="text-center matrix-row-result-header"
            [ngClass]="{
              'matrix-column-large': getColumnsToDisplay().length <= 1,
              'sticky-top': isStickyRow(),
            }"></th>
        }
        @for (column of getColumnsToDisplay(); track column) {
          <th
            class="text-center matrix-point-group-header"
            [ngClass]="{
              'matrix-column-large': getColumnsToDisplay().length <= 1,
              'sticky-top': isStickyRow(),
            }">
            <p>{{ column.pointGroupName | i18nText }}</p>
            <app-detail-result-dropdown
              (resultChange)="columnResultChanged(column)"
              [result]="column.pointGroupResult"
              [resultType]="column.pointGroupResult.inspectionResult"
              [dependingResults]="getDependingResultsForColumn(column)"
              [displayDefectOption]="false"
              [displayEditRemark]="false"
              [readonly]="readonly"
              [elementName]="column.pointGroupName"></app-detail-result-dropdown>
          </th>
        }
        <th
          class="matrix-filler"
          [ngClass]="{
            'sticky-top': isStickyRow(),
          }"></th>
      </tr>
    </thead>
    <tbody>
      @for (point of matrix?.pointsOnCategoryLevel; track point) {
        <tr>
          <td class="text-center">
            {{ point.pointNumber }}
          </td>
          <td
            (click)="
              hasDescription(point.pointDescription) &&
                (point.pointDescriptionDisplayed = !point.pointDescriptionDisplayed)
            "
            class="matrix-point-name"
            [ngClass]="{ clickable: hasDescription(point.pointDescription) }"
            [attr.aria-expanded]="point.pointDescriptionDisplayed"
            [attr.aria-controls]="point.pointNumber">
            @if (hasDescription(point.pointDescription)) {
              <span class="description-icon fas fa-info-circle"></span>
            }
            <div>{{ point.pointName | i18nText }}</div>
            <div id="{{ point.pointNumber }}" [ngbCollapse]="!point.pointDescriptionDisplayed">
              <i class="element-description">{{ point.pointDescription | i18nText }}</i>
            </div>
          </td>
          <td [colSpan]="getPointsOnCategoryLevelColSpan()" class="text-center">
            @if (point.pointResult) {
              <div>
                @if (!point.pointResult.fieldValue) {
                  <app-detail-result-button
                    (resultChange)="pointResultChanged(point.pointResult)"
                    [result]="point.pointResult"
                    [defectDescriptionSuggestions]="point.defectDescriptionSuggestions"
                    [readonly]="readonly"
                    [elementName]="point.pointName"
                    [isFkp]="point.isFkp"></app-detail-result-button>
                }
                @if (
                  point.pointResult.fieldValue &&
                  (point.pointResult.fieldValue.inspectionElementFieldType ===
                    fieldValueTypes.Date ||
                    point.pointResult.fieldValue.inspectionElementFieldType ===
                      fieldValueTypes.Text)
                ) {
                  <app-detail-result-field-value
                    (resultChange)="pointResultFieldValueChanged()"
                    [result]="point.pointResult"
                    [readonly]="readonly"></app-detail-result-field-value>
                }
                @if (
                  point.pointResult.fieldValue &&
                  point.pointResult.fieldValue.inspectionElementFieldType === fieldValueTypes.YesNo
                ) {
                  <app-detail-result-yes-no-button
                    [result]="point.pointResult.fieldValue"
                    (resultChange)="pointResultFieldValueChanged()"
                    [readonly]="readonly"></app-detail-result-yes-no-button>
                }
                @if (
                  point.pointResult.fieldValue &&
                  point.pointResult.fieldValue.inspectionElementFieldType === fieldValueTypes.Number
                ) {
                  <app-detail-result-number-field-value
                    [result]="point.pointResult"
                    (resultChange)="pointResultFieldValueChanged()"
                    [displayRemark]="point.displayRemarkOfFieldValue"
                    [readonly]="readonly"></app-detail-result-number-field-value>
                }
              </div>
            }
          </td>
          <td class="matrix-filler"></td>
        </tr>
      }
      @for (row of matrix?.rows; track row) {
        @if (row.isPointGroup) {
          <tr class="detail-matrix-subhead-point-group">
            <td class="text-center">{{ row.number }}</td>
            <td
              (click)="
                hasDescription(row.description) &&
                  (row.descriptionDisplayed = !row.descriptionDisplayed)
              "
              class="matrix-point-name"
              [ngClass]="{ clickable: hasDescription(row.description) }"
              [attr.aria-expanded]="row.descriptionDisplayed"
              [attr.aria-controls]="row.number">
              @if (hasDescription(row.description)) {
                <span class="description-icon fas fa-info-circle"></span>
              }
              <div>{{ row.name | i18nText }}</div>
              <div id="{{ row.number }}" [ngbCollapse]="!row.descriptionDisplayed">
                <i class="element-description">{{ row.description | i18nText }}</i>
              </div>
            </td>
            @if (displayRowPointTemplateColumn()) {
              <td class="matrix-filler"></td>
            }
            @for (pointGroup of getPointGroupsOfRow(row); track pointGroup) {
              <td class="text-center">
                @if (getDependingResultsForPointGroup(pointGroup).length > 0) {
                  <app-detail-result-dropdown
                    (resultChange)="rowPointGroupResultChanged(pointGroup)"
                    [result]="pointGroup.pointGroupResult"
                    [resultType]="pointGroup.pointGroupResult.inspectionResult"
                    [dependingResults]="getDependingResultsForPointGroup(pointGroup)"
                    [displayDefectOption]="true"
                    [displayEditRemark]="false"
                    [readonly]="readonly"></app-detail-result-dropdown>
                }
              </td>
            }
            <td class="matrix-filler"></td>
          </tr>
        }
        @if (!row.isPointGroup) {
          <tr>
            <td class="text-center">{{ row.number }}</td>
            <td class="matrix-point-name" [attr.aria-controls]="row.number">
              <div>{{ row.name | i18nText }}</div>
            </td>
            @if (displayRowPointTemplateColumn()) {
              <td class="text-center">
                @if (getPointsToDisplay(row)?.length > 1 && !row.isFieldValuePoint) {
                  <app-detail-result-dropdown
                    (resultChange)="rowResultChanged(row)"
                    [result]="row.pointResultModel"
                    [resultType]="row.pointResultModel.inspectionResult"
                    [dependingResults]="getDependingResultsForRow(row)"
                    [displayDefectOption]="true"
                    [displayEditRemark]="true"
                    [readonly]="readonly"
                    [elementName]="row.name"
                    [defectDescriptionSuggestions]="
                      row.defectDescriptionSuggestions
                    "></app-detail-result-dropdown>
                }
              </td>
            }
            @if (!displayRowPointTemplateColumn() && !getColumnsToDisplay().length) {
              <td></td>
            }
            @for (point of getPointsToDisplay(row); track point) {
              <td class="text-center">
                @if (point.result) {
                  <div
                    (click)="
                      hasDescription(point.pointDescription)
                        ? openPointDescriptionDialog(point)
                        : null
                    "
                    class="matrix-point-name bg-transparent position-relative"
                    [ngClass]="{ clickable: hasDescription(point.pointDescription) }"
                    [attr.aria-expanded]="point.pointDescriptionDisplayed"
                    [attr.aria-controls]="point.pointNumber">
                    @if (hasDescription(point.pointDescription)) {
                      <span
                        class="description-icon-left fas fa-info-circle position-absolute"
                        [title]="
                          hasDescription(point.pointDescription)
                            ? (point.pointDescription | i18nText)
                            : null
                        ">
                      </span>
                    }
                  </div>
                  <div>
                    @if (!point.result.fieldValue) {
                      <app-detail-result-button
                        (resultChange)="rowPointResultChanged(point, row.number)"
                        [result]="point.result"
                        [defectDescriptionSuggestions]="point.defectDescriptionSuggestions"
                        [readonly]="readonly"
                        [elementName]="row.name"
                        [isFkp]="point.isFkp"></app-detail-result-button>
                    }
                    @if (
                      point.result.fieldValue &&
                      (point.result.fieldValue.inspectionElementFieldType ===
                        fieldValueTypes.Date ||
                        point.result.fieldValue.inspectionElementFieldType === fieldValueTypes.Text)
                    ) {
                      <app-detail-result-field-value
                        (resultChange)="rowPointResultFieldValueChanged(point)"
                        [result]="point.result"
                        [readonly]="readonly"></app-detail-result-field-value>
                    }
                    @if (
                      point.result.fieldValue &&
                      point.result.fieldValue.inspectionElementFieldType === fieldValueTypes.YesNo
                    ) {
                      <app-detail-result-yes-no-button
                        [result]="point.result.fieldValue"
                        (resultChange)="rowPointResultFieldValueChanged(point)"
                        [readonly]="readonly"></app-detail-result-yes-no-button>
                    }
                    @if (
                      point.result.fieldValue &&
                      point.result.fieldValue.inspectionElementFieldType === fieldValueTypes.Number
                    ) {
                      <app-detail-result-number-field-value
                        [result]="point.result"
                        (resultChange)="rowPointResultFieldValueChanged(point)"
                        [displayRemark]="point.displayRemarkOfFieldValue"
                        [readonly]="readonly"></app-detail-result-number-field-value>
                    }
                  </div>
                }
              </td>
            }
            <td class="matrix-filler"></td>
          </tr>
        }
      }
      @if (matrix && categoryDetail.displayCategoryResult) {
        <tr>
          <td
            colspan="2"
            (click)="
              hasDescription(matrix.summary.categoryDescription) &&
                (matrix.summary.categoryDescriptionDisplayed =
                  !matrix.summary.categoryDescriptionDisplayed)
            "
            class="matrix-point-name"
            [ngClass]="{ clickable: hasDescription(matrix.summary.categoryDescription) }"
            [attr.aria-expanded]="matrix.summary.categoryDescriptionDisplayed"
            [attr.aria-controls]="categoryDetail.categoryNumber">
            @if (hasDescription(matrix.summary.categoryDescription)) {
              <span class="description-icon fas fa-info-circle"></span>
            }
            <h3>
              <span translate>Gesamtbeurteilung</span
              ><span>&nbsp;{{ categoryDetail.categoryName | i18nText }}</span>
            </h3>
            <div
              id="{{ categoryDetail.categoryNumber }}"
              [ngbCollapse]="!matrix.summary.categoryDescriptionDisplayed">
              <i class="element-description">{{ matrix.summary.categoryDescription | i18nText }}</i>
            </div>
          </td>
          <td
            [colSpan]="
              getColumnsToDisplay().length +
              (displayRowPointTemplateColumn() || !getColumnsToDisplay().length ? 1 : 0)
            "
            class="text-center">
            <app-detail-category-result
              (resultChange)="categoryResultChanged($event)"
              [result]="matrix.summary.categoryResult"
              [resultType]="matrix.summary.categoryResult.inspectionResult"
              [hasDefects]="hasDefects"
              [readonly]="readonly"></app-detail-category-result>
          </td>
          <td class="matrix-filler"></td>
        </tr>
      }
    </tbody>
  </table>
</div>
